<div class="container-fluid product-not-found arb-clear-text-for-table" *ngIf="!productOutput.productInfo && productNotFound">
  Sorry! We cannot find the product.
</div>

<div class="product-loading d-flex align-items-center justify-content-center" *ngIf="!productOutput.productInfo && isProductLoading$ |async ">
  <i class="pi pi-spin pi-spinner"></i>Retrieving Product Information...
</div>
<div class="container-fluid product-container arb-clear-text-for-table" *ngIf="productOutput.productInfo" [busyIf]="isProductLoading$ |async ">
  <app-product-product-summary
    [product]="productOutput.productInfo"
    [class.add-to-order-error]="failedOrderItemNumbers.has(mainProduct.companySKU)"
    [hasAssociatedFittmentWarning]="hasAssociatedFittmentWarning"
    [hasSelectedVehicle]="!!selectedVehicleId"
    [isFitted]="isFitted"
  ></app-product-product-summary>
  <app-product-prices-stocks
    #pricesStocks
    [stocks]="mainProduct.stocks"
    [isBundle]="mainProduct?.isBundle"
    [basedPrices]="mainProduct.prices"
    [images]="productOutput.images"
  ></app-product-prices-stocks>
  <app-product-add-to-order
    #addToOrder
    [product]="mainProduct"
    [selectedItemCount]="selectedOrderItemCount"
    [includeParent]="includeParent"
    (includeParentChange)="onIncludeParentChange($event)"
    [readOnlyEPCTF]="readOnlyEPCTF"
    [currencyCode]="currencyCode"
    [totalPrice]="configuredPrices[0]?.totalPrice"
    [hasAssociatedItemWarning]="hasAssociatedItemWarning"
    (addedToOrder)="addItemToOrder($event)"
    (updatedQuantity)="updateMainProductPrices()"
    (addToOrderInProgress)="onAddToOrderInProgress()"
  ></app-product-add-to-order>

  <div class="row" style="margin-top: 20px">
    <div class="col-md-12">
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" [destroyOnHide]="true">
        <li [ngbNavItem]="1">
          <a class="arb-field-label" ngbNavLink>Associated Items</a>
          <ng-template ngbNavContent>
            <app-product-associated-items
              [items]="associatedItems"
              [failedOrderItemNumbers]="failedOrderItemNumbers"
              [failedOrderItemMessages]="failedOrderItemMessages"
              [includeParent]="includeParent"
              [currencyCode]="currencyCode"
              [fitLabel]="productOutput.fitDescription"
              [addFitLabel]="productOutput.addFitDescription"
              (orderItemsChanged)="updateOrderItem($event)"
              (changeEAIRules)="recievechangeEAIRules($event)"
              [priceAndStockItems]="priceAndStockItems"
            ></app-product-associated-items>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a class="arb-field-label" ngbNavLink>Product Description</a>
          <ng-template ngbNavContent>
            <app-product-product-details [product]="productOutput.productInfo"></app-product-product-details>
          </ng-template>
        </li>
        <li [ngbNavItem]="3">
          <a class="arb-field-label" ngbNavLink>Tech Specs</a>
          <ng-template ngbNavContent>
            <app-product-tech-specs
              [productInfoAttribute]="productInfoAttribute"
              [productFitmentInfoAttribute]="productFitmentInfoAttribute"
            ></app-product-tech-specs>
          </ng-template>
        </li>
        <li [ngbNavItem]="4">
          <a class="arb-field-label" ngbNavLink>Applications</a>
          <ng-template ngbNavContent>
            <app-product-applications [applications]="productOutput.applications" [selectedVehicleId]="selectedVehicleId"></app-product-applications>
          </ng-template>
        </li>
        <li [ngbNavItem]="5">
          <a class="arb-field-label" ngbNavLink>Product Resources</a>
          <ng-template ngbNavContent>
            <app-product-fitting-instructions
              [supplierUrl]="productOutput.productInfo.supplierUrl"
              [supersededProductNumber]="productOutput.productInfo.supersededProductNumber"
              [fittingInstructions]="productOutput.fittingInstructions"
            ></app-product-fitting-instructions>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class=" "></div>
    </div>
  </div>
</div>
